import { styled } from "@l2r-front/l2r-ui"

export const StatsContainer = styled("div")({
    display: "flex",
    flexDirection: "row",
})